<aside class="cr-right-panel" #rightPanel [style.width.px]="panelWidth">
  <div class="cr-right-resize-handle" (mousedown)="startResize($event)"></div>
  <div class="cr-right-head" *ngIf="reviewMode === 'off'">
    <button
      type="button"
      class="cr-panel-tab"
      [class.active]="activeTab === 'properties'"
      (click)="setTab.emit('properties')"
    >
      Block Properties
    </button>
    <button
      type="button"
      class="cr-panel-tab"
      [class.active]="activeTab === 'comments'"
      (click)="setTab.emit('comments')"
    >
      Comments
      <span class="cr-comment-badge" *ngIf="commentCount">{{ commentCount }}</span>
    </button>
  </div>

  <div class="cr-right-body">
    <ng-container *ngIf="reviewMode === 'off' && activeTab === 'properties'">
      <div class="cr-system-fields-panel" *ngIf="subjectBlock || preheaderBlock || alwaysVisibleBlocks.length">
        <section
          class="cr-settings-block cr-settings-block-system"
          [class.active]="selectedBlockId === subjectBlock.blockId"
          [attr.data-block-id]="subjectBlock.blockId"
          *ngIf="subjectBlock"
          (focusin)="focusBlock.emit(subjectBlock.blockId)"
        >
          <div class="cr-settings-block-head">
            <span class="cr-settings-index">{{ blockIndex(subjectBlock) }}</span>
            <span class="cr-settings-title">Subject</span>
          </div>
          <!-- Keyed by object identity, so undo/redo (which gives a changed block
               a new object) recreates the form and it shows the restored text. -->
          <ng-container *ngFor="let block of [subjectBlock]">
            <app-subject-v2
              [block]="block"
              [isPreview]="false"
              [disabled]="fieldsDisabled"
              (blockData)="blockData.emit($event)"
            ></app-subject-v2>
          </ng-container>
        </section>
        <section
          class="cr-settings-block cr-settings-block-system"
          [class.active]="selectedBlockId === preheaderBlock.blockId"
          [attr.data-block-id]="preheaderBlock.blockId"
          *ngIf="preheaderBlock"
          (focusin)="focusBlock.emit(preheaderBlock.blockId)"
        >
          <div class="cr-settings-block-head">
            <span class="cr-settings-index">{{ blockIndex(preheaderBlock) }}</span>
            <span class="cr-settings-title">Preheader</span>
          </div>
          <!-- Keyed by object identity, same as Subject above. -->
          <ng-container *ngFor="let block of [preheaderBlock]">
            <app-preheader-v2
              [block]="block"
              [isPreview]="false"
              [disabled]="fieldsDisabled"
              (blockData)="blockData.emit($event)"
            ></app-preheader-v2>
          </ng-container>
        </section>

        <!-- Block types with a dedicated always-visible v2 form (e.g. Main Banner)
             get their own permanent section here, same as Subject/Preheader above -
             every instance stays visible and editable regardless of sidebar
             selection, instead of the master-detail "one at a time" behavior below.
             *ngFor (not a single reused slot) also means each instance keeps its
             own component tree, so switching between two of the same type never
             shows stale data from the other one. Tracked by object identity (the
             ngFor default), so a block that undo/redo replaced gets a new form. -->
        <section
          class="cr-settings-block cr-settings-block-system"
          [class.active]="selectedBlockId === block.blockId"
          [attr.data-block-id]="block.blockId"
          *ngFor="let block of alwaysVisibleBlocks"
          (focusin)="focusBlock.emit(block.blockId)"
        >
          <div class="cr-settings-block-head">
            <span class="cr-settings-index">{{ blockIndex(block) }}</span>
            <span class="cr-settings-title">{{ displayName(block) }}</span>
          </div>
          <app-block-renderer-v2
            [block]="block"
            [isPreview]="false"
            [disabled]="fieldsDisabled"
            (blockData)="blockData.emit($event)"
            (removeBlockEvent)="removeBlockEvent.emit($event)"
          ></app-block-renderer-v2>
        </section>
      </div>

      <section class="cr-settings-block" [attr.data-block-id]="selectedBlock.blockId" *ngIf="isOtherBlockSelected">
        <div class="cr-settings-block-head">
          <span class="cr-settings-title">{{ displayName(selectedBlock) }}</span>
          <button type="button" class="cr-icon-btn cr-close-selected" (click)="closeSelected.emit()" title="Close">
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
              <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <div class="cr-properties-only">
          <!-- Keyed by object identity (not just *ngIf="isOtherBlockSelected"
               above) so switching between two blocks of the SAME type, or undo/redo
               replacing the selected block with a restored object, destroys and
               recreates this whole subtree instead of rebinding [block] on a
               reused instance - otherwise nested app-block-text (unmodified,
               ngOnInit-only blockData->inputData copy) keeps showing stale text. -->
          <ng-container *ngFor="let block of [selectedBlock]">
            <app-block-renderer-v2
              [block]="block"
              [isPreview]="false"
              [disabled]="fieldsDisabled"
              (blockData)="blockData.emit($event)"
              (removeBlockEvent)="removeBlockEvent.emit($event)"
            ></app-block-renderer-v2>
          </ng-container>
        </div>
      </section>
    </ng-container>

    <app-review-panel-v2
      *ngIf="reviewMode !== 'off' || activeTab === 'comments'"
      [compact]="reviewMode === 'off'"
      [currentUsername]="currentUsername"
      [languageLabel]="languageLabel"
      [canRestore]="canRestore"
      [selectedBlockId]="selectedBlockId"
      (newVersion)="newVersion.emit()"
      (restoreVersion)="restoreVersion.emit($event)"
    ></app-review-panel-v2>
  </div>
</aside>
